'use client'

import { Button } from '@inflow/ui/components/button'
import { Card } from '@inflow/ui/components/card'
import { motion } from 'motion/react'
import Link from 'next/link'
import { containerStagger, fadeUp } from '../../base-animations'
import HeroTitle from '../HeroTitle'

const _MotionCard = motion(Card)
const MotionLink = motion(Link)

export default function () {
  return (
    <Card
      className="mx-auto grid h-full w-full max-w-hero content-center justify-items-center gap-3 bg-center bg-cover"
      style={{ backgroundImage: "url('/images/bgd.webp')" }}
    >
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.1,
          margin: '-10% 0px -20% 0px',
        }}
        variants={containerStagger(0.44, 0.33)}
      >
        <HeroTitle
          desktopAlignment="center"
          title="Enrich your insights"
          subTitle="Access Gerard Minack’s research and analysis"
        >
          <MotionLink
            href="/contact"
            variants={fadeUp(1)}
          >
            <Button>Contact</Button>
          </MotionLink>
        </HeroTitle>
      </motion.div>
    </Card>
  )
}
